/** Display strings for `CrmValidationSummarySection` — set per CRM in `SyncConflictModal`. */

export const HUBSPOT_VALIDATION_SUMMARY_TITLE = 'HubSpot validation summary';

export const HUBSPOT_VALIDATION_SUMMARY_DESCRIPTION =
  'Invalid values will be dropped (set to null in HubSpot). For creates, all mapped fields are validated. For updates, only fields with overwrite enabled are validated and counted.';

export const SALESFORCE_VALIDATION_SUMMARY_TITLE =
  'Salesforce validation summary';

export const SALESFORCE_VALIDATION_SUMMARY_DESCRIPTION =
  'Invalid values will be dropped or cleared in Salesforce when possible. For creates, all mapped fields are validated. For updates, only fields with overwrite enabled are validated and counted.';
